import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@material-ui/core/Button';

import classes from './AspModal.module.css';
import Backdrop from '../Backdrop/Backdrop';

class AspModal extends Component {

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.show !== this.props.show || nextProps.children !== this.props.children;
    }

    componentWillUpdate() {
    }

    render() {
        return (
            <div>
                <Backdrop show={this.props.show} clicked={this.props.okButtonHandler} />
                <div
                    className={classes.Modal}
                    style={{
                        transform: this.props.show ? 'transformY(0)' : 'transformY(-100vh)',
                        display: this.props.show ? "block" : 'none'
                    }}>
                    <div style={{ margin: "0 20px 20px 20px" }}>
                        <FontAwesomeIcon icon={this.props.icon} size={this.props.size} color={this.props.color} />
                    </div>
                    <div className={classes.ModalTextStyle}>
                        {this.props.displayText1}
                    </div>
                    <div className={classes.ModalTextStyle}>
                        {this.props.displayText2}
                    </div>
                    <div className={classes.CancelButtonConatiner}>
                        <Button
                            variant="contained"
                            classes={{ root: classes.CancelButton }}
                            href=""
                            onClick={this.props.okButtonHandler}>
                            {this.props.buttonText1}
                        </Button>
                        {
                            this.props.cancelButtonHandler ?
                                <Button
                                    variant="contained"
                                    classes={{ root: classes.CancelButton }}
                                    href=""
                                    onClick={this.props.cancelButtonHandler}>
                                    {this.props.buttonText2}
                                </Button> : ''
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default AspModal;